import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import ReactPlaceholder from 'react-placeholder'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'

const useStyles = makeStyles({
  root: {
    display: 'block',
    color: '#4E4D4D',
    paddingTop: 27,
    paddingBottom: 27
  }
})

const TopicCardDescription = ({ children, loading, error = false }) => {
  const classes = useStyles()
  useEffect(() => {
    (window.MathJax || {}).typeset && (window.MathJax || {}).typeset()
  })
  if(error) {
    return (
      <Typography component={'div'} className={classes.root}>
        <div style={{ display: 'flex', alignItems: 'center'}}>
          <ErrorOutlineIcon style={{ marginRight: 10, fontSize: 32 }} /> <strong> Tópico não encontrado.</strong>
        </div>
      </Typography>
    )
  }
  return (
    <Typography className={classes.root}>
      {loading ? (
        <ReactPlaceholder showLoadingAnimation ready={false} type="text" rows={4} />
      ) : (
        <div dangerouslySetInnerHTML={{ __html: (children || '').replace(/<math>|<\/math>/gi, '`') }} />
      )}
    </Typography>
  )
}
export default TopicCardDescription
